import * as types from './constants'

const initialState = {
    cart: [],
    addresses: [],
    addressIsLoading: false,

    submittingOrderId: null,
    submittingOrder: false,
}

const reducer = (state = initialState, actions) => {
    switch (actions.type) {
        case types.ADD_TO_CART:
            return {
                ...state,
                cart: [...state.cart, actions.payload],
            }
        case types.SET_CART:
            return {
                ...state,
                cart: actions.payload,
            }
        case types.RESET_CART:
            return {
                ...state,
                cart: [],
            }
        case types.GET_ADDRESSES_START:
            return {
                ...state,
                addressIsLoading: true,
            }
        case types.GET_ADDRESSES_SUCCESS:
            return {
                ...state,
                addresses: actions.payload,
                addressIsLoading: false,
            }
        case types.GET_ADDRESSES_FAIL:
            return {
                ...state,
                addressIsLoading: false,
            }
        case types.SUBMIT_ORDER_START:
            return {
                ...state,
                submittingOrder: true,
            }
        case types.SUBMIT_ORDER_SUCCESS:
            return {
                ...state,
                submittingOrderId: actions.payload,
                submittingOrder: false,
            }
        case types.SUBMIT_ORDER_FAIL:
            return {
                ...state,
                submittingOrder: false,
            }

        default:
            return state
    }
}

export default reducer
